import React from 'react';
import '../styles/footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p>© 2026</p>
    </footer>
  );
}

export default Footer;
